import { Form, Row, Col,Cascader } from 'antd';
export const AccountInvestmentOptions = (props) => {
  const { form, investmentOptions } = props; // Destructure form and investmentOptions from props

  return (
    <>
      <Form form={form} name="basic" layout="vertical" className="forms">
          <Row align='start'>
            <Col span={20}>
            <Form.Item>
              <label>Additional investment options and services may be available. Contact your Client Service Team for further details.</label>
            </Form.Item>
          </Col>
          </Row>
        <Row>
          <Col span={4}>
            <Form.Item>
              <label>Investment Options:</label>
            </Form.Item>
          </Col>
          <Col span={20}>
            <Form.Item name="mvarIsAccBonds" rules={[
              {
                required: true,
                message: 'Investment Options Required',
              },
              ]}>
              <Cascader
                placeholder="Select Investment Options"
                style={{ width: '100%' }}
                options={investmentOptions}
                multiple
                maxTagCount="responsive"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};